export default __webpack_public_path__ + "static/media/GDSymbolsImg.0f83cdb8.jpg";